<template>
  <div id="terminalWrapper">
    <!-- 搜索栏 -->
    <div class="search-box">
      <div>
        <Input v-model="searchValue" prefix="ios-search-outline" placeholder="请输入用户姓名"
          style="width: 208px; margin-right: 10px;" @on-enter="handleSearchClick" />
        <Button class="ys-confirm" @click="handleSearchClick">搜索</Button>
      </div>
      <div></div>
    </div>
    <!-- 表格 -->
    <el-table :columns="Columns" :tableData="tableData" :loading="tableLoading" :tableHeight="tableHeight"></el-table>
    <!-- 分页 -->
    <div class="paging-box">
      <Page :page-size="12" :total="totalCount" :current="page" @on-change="handlePagingClick" />
    </div>
  </div>
</template>
<script>
  import {
    mapActions
  } from "vuex";
  import elementResizeDetectorMaker from "element-resize-detector"; // 获取元素的高度
  import ElTable from '_g/commonComponent/table/elTable.vue';
  import Columns from './tableConfig.js'
  export default {
    components: {
      'el-table': ElTable
    },
    data() {
      return {
        tableData: [], // 数据
        Columns: [], // 表头
        totalCount: 0, // 总条数
        tableHeight: 0,
        page: 1, // 当前页
        searchValue: '', // 搜索框的值
        tableLoading: true, // 表格loading
      }
    },
    methods: {
      ...mapActions([
        'pageOnlyUserTermActionList', // 列表
      ]),
      // 获取元素的高度
      getElementHeight() {
        let ERD = elementResizeDetectorMaker();
        let _this = this;
        ERD.listenTo(document.getElementById("terminalWrapper"), (element) => {
          _this.tableHeight = (element.offsetHeight - 66 - 60 - 20); // 在该基础上多-20跟分页有间距
        });
      },
      // 搜索功能
      handleSearchClick() {
        this.page = 1;
        // 获取列表
        this.pageOnlyUserTermActionLists();
      },
      // 分页功能
      handlePagingClick(res) {
        this.page = res;
        // 获取列表
        this.pageOnlyUserTermActionLists();
      },
      // 獲取搜索列表
      async pageOnlyUserTermActionLists() {
        try {
          this.tableLoading = true;
          let ev = {
            user_cn_name: this.searchValue || '', // 用户名查询
            start_recd: (this.page - 1) * 12,
            limit_recd: 12
          }
          const data = await this.pageOnlyUserTermActionList(ev);
          if (data.request_state) {
            this.totalCount = data.all_recd;
            this.tableData = data.list;
            this.tableLoading = false;
          }
        } catch (error) {
          console.log(error);
          this.tableLoading = false;
        }
      }
    },
    mounted() {
      this.Columns = Columns;
      // 获取元素高度
      this.getElementHeight();
      // 獲取列表
      this.pageOnlyUserTermActionLists();
    }
  }
</script>
<style lang="less" scoped>
  #terminalWrapper {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 50px;
    box-sizing: border-box;

    .search-box {
      width: 100%;
      height: 66px;
      padding: 22px 0px 12px 0px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
    }

    .paging-box {
      position: fixed;
      bottom: 0px;
      right: 50px;
      z-index: 1;
      height: 60px;
      width: calc(100% - 250);
      text-align: right;
    }
  }
</style>